<template>
    <div class="header">
        <button class="restart" v-if="gameType=='training'" @click="restart"><h1>herstart</h1></button>
        <h1 v-if="gameType=='fruitmachine'">Level </h1>
        <app-levelselect v-if="gameType=='fruitmachine'" :currentLevel="currentLevel" :levelStatuses="levelStatuses"></app-levelselect>
        <div @click="showHelp" class="helpButton">
            <h4>?</h4>
        </div>
    </div>
</template>

<script>
import { eventBus } from "../main";
import LevelSelect from "./levelSelect.vue";

export default {
    name: "AGFHeader",
    props: {
        currentLevel: {
            type: Number,
            default: 1
        },
        levelStatuses: {
            type:Array,
            required: true
        },
        gameType: {
            type: String,
            required: true
        }
    },
    components: {
        appLevelselect: LevelSelect
    },
    methods: {
        showHelp() {    
            eventBus.$emit("toggleHelp");        
        },
        restart() {    
            eventBus.$emit("tryAgain");        
        }
    }
};
</script>

<style scoped>
h1 {
    font-size: 3vh;
    float: left;
    margin: 0;
    color: #ffc500;
}
h3 {
    float: right;
    margin: 0.5vh 0;
    color: #8a3a00;
}
h4 {
    font-size: 2.75vh;
    color: #8a3a00;
}
.header {
    position:absolute;
    top:0;
    left:0;
    z-index:200;
    width: 100%;
    height: 6%;
    box-sizing: border-box;
    padding: 2% 2%;
    background: #fff;
    position: relative;

    -webkit-box-shadow: 0px 0.5vh 0.5vh 0px rgba(0, 0, 0, 0.25);
    -moz-box-shadow: 0px 0.5vh 0.5vh 0px rgba(0, 0, 0, 0.25);
    box-shadow: 0px 0.5vh 0.5vh 0px rgba(0, 0, 0, 0.25);
}
button {
    border:none;
    background:none;
    cursor: pointer;
}
.logo {
    float: left;
    height: 100%;
}
.helpButton {
    position: absolute;
    top: 0.5vh;
    right: 0.5vh;
    border: 0.5vh solid #8a3a00;
    border-radius: 100%;
    height: 5vh;
    width: 5vh;
    text-align: center;
    padding-left: 0.5vh;
    box-sizing: border-box;
}
.helpButton:hover {
    cursor: pointer;
}
.restart {
    display:inline-block;
    width:80%;
}
.restart h1 {
    width:100%;
    text-align: center;
}
</style>
